"use strict";
/**
 * @module Client
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Defined reason code and message used to report client close conditions.
 */
var CloseReasonImpl = /** @class */ (function () {
    /**
     * Create a `CloseReason`
     *
     * @param  id           the close reason's id
     * @param  message      the close reason's description
     * @param  canReconnect whether the session can reconnect from this state
     */
    function CloseReasonImpl(id, message, canReconnect) {
        this.id = id;
        this.message = message;
        this.canReconnect = canReconnect;
    }
    /**
     * Convert to string
     *
     * @return string representation of the close reason
     */
    CloseReasonImpl.prototype.toString = function () {
        return 'id: ' + this.message;
    };
    return CloseReasonImpl;
}());
exports.CloseReasonImpl = CloseReasonImpl;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/client/close-reason.js
// module id = 604
// module chunks = 1